import React, {Fragment, useState} from 'react';
import {
  GridIcon,
  HamburgerMenuIcon,
  InfoIcon,
  MicOffIcon,
  RecordIcon,
  SettingsIcon,
  TextboxIcon,
  CopyIcon,
} from '@100mslive/react-icons';
import {
  selectLocalPeerID,
  selectLocalPeerRole,
  selectPermissions,
  useHMSStore,
} from '@100mslive/react-sdk';
import {Box, Dropdown, Text, Tooltip, Flex, VerticalDivider} from '@100mslive/roomkit-react';
import {ChangeSelfRole} from './ChangeSelfRole';
import {FullScreenItem} from './FullScreenItem';
import {UISettings} from './UISettings';
import Settings from '../Settings';
import {RoleChangeModal} from '../RoleChangeModal';
import {ChangeNameModal} from './ChangeNameModal';
import {StatsForNerds} from '../StatsForNerds';
import {MuteAllModal} from './MuteAllModal';
import {RecordingAndRTMPModal} from './RecordingAndRTMPModal';
import {FeatureFlags} from '../../services/100-ms-services/FeatureFlags';
import {ToastManager} from '../Toast/ToastManager';
import {ScreenshareToggle} from '../UI-Components/ScreenShare';
import {MetaActions} from '../Footer';

const hoverStyles = {
  '&:hover': {
    cursor: 'pointer',
    bg: '$iconHoverBg',
    backgroundColor: "$surface_bright"
  },
  '&:focus-visible': {
    bg: '$iconHoverBg',
  },
};

export const MoreSettings = ({meetingUrl,isMobile,switchFullScreen}: any) => {
  const permissions = useHMSStore(selectPermissions);
  const localPeerId = useHMSStore(selectLocalPeerID);
  const hmsStore = useHMSStore(selectLocalPeerRole);
  console.log(hmsStore, 'hmsStoreRole');
  const [open, setOpen] = useState(false);
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);
  const [showRecordingModal, setShowRecordingModal] = useState(false);
  const [showMuteAll, setShowMuteAll] = useState(false);
  const [showDeviceSettings, setShowDeviceSettings] = useState(false);
  const [showStatsForNerds, setShowStatsForNerds] = useState(false);
  const [showUISettings, setShowUISettings] = useState(false);
  const [showSelfRoleChange, setShowSelfRoleChange] = useState(false);

  return (
    <Fragment>
      <Dropdown.Root open={open} onOpenChange={setOpen}>
        <Dropdown.Trigger asChild data-testid="more_settings_btn">
          <div style={{marginTop:6,marginLeft:10}}>
            <Tooltip title="More Options">
              <Box>
                {/* <HamburgerMenuIcon /> */}
                <img
                  src={require('../../asset/icons/more.png')}
                  alt='logo'
                  width='20px'
                  style={{marginBottom:isMobile ? 2 : 6}}
                />
              </Box>
            </Tooltip>
            <div style={{fontSize:12,color:'white',marginTop: isMobile ? 6 : 2}}>More</div>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Content
          sideOffset={5}
          align="center"
          css={{maxHeight: '$96'}}>
          {hmsStore?.name == 'role-doc' && (
            <>
            <Dropdown.Item
              css={hoverStyles}
              onClick={() => {
                const toastId = ToastManager.addToast({
                  title: 'Meeting Link Copied',
                });
                const elem = document.createElement('textarea');
                elem.value = meetingUrl;
                // document.body.appendChild(elem);
                elem.select();
                navigator.clipboard.writeText(elem.value);
                // document.execCommand('copy');
                // document.body.removeChild(elem);
                console.log(toastId);
                setTimeout(() => {
                  ToastManager.removeToast(toastId);
                }, 3000);
              }}
              data-testid="change_name_btn">
              <CopyIcon />
              <Text variant="sm" css={{ml: '$4',fontWeight:600}}>
                Copy invite link
              </Text>
            </Dropdown.Item>
            </>
          )}

          <Dropdown.Item
            css={hoverStyles}
            onClick={() => setShowChangeNameModal((value) => !value)}
            data-testid="change_name_btn">
            <TextboxIcon />
            <Text variant="sm" css={{ml: '$4',fontWeight:600}}>
              Change Name
            </Text>
          </Dropdown.Item>
          <ChangeSelfRole
            css={hoverStyles}
            onClick={() => setShowSelfRoleChange(true)}
          />
          <FullScreenItem switchFullScreen ={switchFullScreen} hoverStyles={hoverStyles} />
          <Dropdown.Item
            onClick={() => setShowDeviceSettings(true)}
            css={hoverStyles}
          data-testid="device_settings_btn">
            <SettingsIcon />
            <Text variant="sm" css={{ml: '$4',fontWeight:600}}>
              Device Settings
            </Text>
          </Dropdown.Item>
          {FeatureFlags.enableStatsForNerds && (
            <Dropdown.Item
              onClick={() => setShowStatsForNerds(true)}
              css={hoverStyles}
              data-testid="stats_for_nreds_btn">
              <InfoIcon />
              <Text variant="sm" css={{ml: '$4',fontWeight:600}}>
                Stats for Nerds
              </Text>
            </Dropdown.Item>
          )}
          {isMobile && <div>
            <Dropdown.Item>
              <Flex align="center" justify="center">
                <ScreenshareToggle isMobile={isMobile} css={{mx: '$4'}} />
                  <VerticalDivider style={{background:'#E4E7EC'}}/>
                <MetaActions isMobile={true}/>
              </Flex>
            </Dropdown.Item>
          </div>}
        </Dropdown.Content>
      </Dropdown.Root>
      {showMuteAll && <MuteAllModal onOpenChange={setShowMuteAll} />}
      {showChangeNameModal && (
        <ChangeNameModal onOpenChange={setShowChangeNameModal} />
      )}
      {showRecordingModal && (
        <RecordingAndRTMPModal onOpenChange={setShowRecordingModal} />
      )}
      {showDeviceSettings && (
        <Settings open onOpenChange={setShowDeviceSettings} />
      )}
      {FeatureFlags.enableStatsForNerds && showStatsForNerds && (
        <StatsForNerds
          open={showStatsForNerds}
          onOpenChange={setShowStatsForNerds}
        />
      )}
      {showUISettings && (
        <UISettings open={showUISettings} onOpenChange={setShowUISettings} />
      )}
      {showSelfRoleChange && (
        <RoleChangeModal
          peerId={localPeerId}
          onOpenChange={setShowSelfRoleChange}
        />
      )}
    </Fragment>
  );
};
